// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2Gaa4","header":"PatientQuestionnaire_header__2w6Bg","info":"PatientQuestionnaire_info__2R32o"};